const KEY = 'flowgate.pendingInvite';

/**
 * Where to land after signing in, when the reason for signing in was an invitation.
 *
 * Google's sign-in leaves and re-enters the app through the backend, so a `next` query parameter
 * would have to survive a redirect we do not control. The token goes in sessionStorage instead:
 * same tab, same origin, gone when the tab closes, and both ways of signing in read it in the
 * one place they agree on, the moment they would otherwise send somebody to the flows list.
 */
export function rememberInvite(token) {
  try {
    window.sessionStorage.setItem(KEY, token);
  } catch {
    // Private browsing can refuse. The invitation link still works by hand.
  }
}

/** The path to go to after a successful sign-in; clears the pending invitation as it reads it. */
export function afterSignInPath(fallback = '/') {
  try {
    const token = window.sessionStorage.getItem(KEY);
    if (token) {
      window.sessionStorage.removeItem(KEY);
      return `/invite/${token}`;
    }
  } catch {
    // Same as above; the fallback is always right.
  }
  return fallback;
}
